// extracted by mini-css-extract-plugin
export default {"container":"PDgi2x","headerContainer":"i_XAD8","commentCount":"ptVXLW","text":"v32P9x","buttonContainer":"Tuj89s","errorCode":"IEHfwt"};